import ENDPOINTS from '@/config/http/endpoints'
import { parseResponse } from '@/config/http/http.helpers'
import { ApiFetchMenuSchema } from '@/ducks/menu/menu.schema'
import { ApiFetchMenu } from '@/ducks/menu/menu.types'
import type { AffectedDeal } from '@/ducks/offers/offers.types'
import { rootApi } from '@/ducks/root.api'
import { ApiBaseResponse } from '@/ducks/slice.types'

import { IEditMenuItemDTO } from './menu.api.types'

export const menuApi = rootApi.injectEndpoints({
  endpoints: build => ({
    fetchMenuList: build.query<
      ApiFetchMenu,
      Parameters<typeof ENDPOINTS.MENU_LIST>[0]
    >({
      providesTags: [{ type: 'Menu', id: 'LIST' }],
      query: ({ store_id }) => ({
        method: 'GET',
        url: ENDPOINTS.MENU_LIST({ store_id })
      }),
      transformResponse: (response: ApiFetchMenu) => {
        return parseResponse(response, ApiFetchMenuSchema)
      }
    }),
    editMenuItem: build.mutation<
      ApiBaseResponse,
      Partial<IEditMenuItemDTO> & { food_id: string; store_id?: string }
    >({
      invalidatesTags: (_result, _error) => [{ type: 'Menu', id: 'LIST' }],
      query: data => ({
        method: 'PUT',
        url: ENDPOINTS.EDIT_MENU_ITEM,
        data
      })
    }),
    hideMenuItem: build.mutation<
      ApiBaseResponse & { affectedDeals?: AffectedDeal[] },
      { item_id: string; storeId?: string }
    >({
      invalidatesTags: (_result, _error, { item_id }) => [
        { type: 'Menu', id: 'LIST' },
        { type: 'Orders', id: item_id }
      ],
      query: data => ({
        method: 'PATCH',
        url: ENDPOINTS.HIDE_MENU_ITEM,
        data
      })
    }),
    showMenuItem: build.mutation<
      ApiBaseResponse,
      { item_id: string; storeId?: string }
    >({
      invalidatesTags: (_result, _error, { item_id }) => [
        { type: 'Menu', id: 'LIST' },
        { type: 'Orders', id: item_id }
      ],
      query: data => ({
        method: 'PATCH',
        url: ENDPOINTS.SHOW_MENU_ITEM,
        data
      })
    })
  })
})

export const {
  useFetchMenuListQuery,
  useShowMenuItemMutation,
  useHideMenuItemMutation,
  useEditMenuItemMutation,
  useLazyFetchMenuListQuery
} = menuApi

export default menuApi
